import React, { useState, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import moment from 'moment';
import {
    Grid,
    TextField,
    CircularProgress
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import MobileDetect from 'mobile-detect'

import Button from '../Button'
import VisitInformation from '../VisitInformation';
import PDFSingleViewer from '../PDFSingleViewer';
import ImgSingleViewer from '../ImgSingleViewer';
import { makeS3BlobsRenderable } from '../../util/fileHandling'
import { fetchConsultNoteAttachments } from '../../services/api'

const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true,
};

function ApptRequestAttachmentPreview(props) {
    const {
        appointment,
        viewOnly,
        classes: {
            root,
            confirmationFields,
            previewImg,
            textCenter,
            modal,
            modalContent,
            btnSpacing,
            customFloatLeft
        },
    } = props;

    const [images, setImages] = useState([]);
    const [currentPDF, setCurrentPDF] = useState([]);
    const [openPDFModal, setOpenPDFModal] = useState(false);
    const [currentImg, setCurrentImg] = useState('');
    const [openImgModal, setOpenImgModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const { patient, startTimestamp, toProvider: withProvider } = appointment;
    let withProviderTitle = withProvider.name;
    if (withProvider.fullTitle) {
        withProviderTitle = `${withProvider.fullTitle} ${withProvider.name}`;
    }
    const tenancy = withProvider.tenancy || {};
    const appointmentStart = moment(startTimestamp);

    const md = new MobileDetect(window.navigator.userAgent);
    const isMobile = md.mobile()

    useEffect(() => {
        (async () => {
            // attaching documents for upload
            const apiResponse = await fetchConsultNoteAttachments(appointment.id);

            const imageObjects = makeS3BlobsRenderable(apiResponse.data);

            setImages(imageObjects);
            setIsLoading(false)
        })();
    }, []);

    const handleOpenImg = link => {
        setOpenImgModal(true);
        setCurrentImg(link);
    };

    const handleOpenPDF = link => {
        setOpenPDFModal(true);
        setCurrentPDF(link);
    };

    const downloadAll = () => {
        var link = document.createElement('a');

        link.setAttribute('download', 'attachments');
        link.style.display = 'none';

        document.body.appendChild(link);

        for (var i = 0; i < images.length; i++) {
            link.setAttribute('href', images[i].dataUrl);
            link.click();
        }

        document.body.removeChild(link);
    }


    return isLoading ? (
        <div className={props.classes.loading}>  <CircularProgress /></div>) : (
            <>
            <div className="attachmentView">
                <Grid container spacing={12} className={root}>
                    {/* <Grid item xs={12} sm={4} className={visitInfo}>
                <VisitInformation
                    provider={withProvider}
                    tenancy={tenancy}
                    appointmentTime={appointmentStart}
                />
            </Grid> */}
            <div className="paddingZero">
                    <Grid item xs={12} sm={12}>
                        <div className={confirmationFields}>
                            {images &&
                                images.length > 0 && isMobile && !viewOnly ?
                                <div>{images.length} images attached</div> :
                                images.map((image, index) => image ?.fileType === 'pdf' ? (
                                    <>
                                          <div className={btnSpacing} >
                                                <span>{index + 1 + '.'}</span> &nbsp;&nbsp;
                                                <Button
                                                    color="primary"
                                                    disabled={image ?.fileType === 'htm' || image ?.fileType === 'html;base6' }
                                                    variant="contained"
                                                   onClick={() => handleOpenPDF(image.dataUrl)}
                                                >
                                                    Click To Preview
                                              </Button><div>To see full report, please click download all button</div>
                                            </div>

                                        <PDFSingleViewer
                                            openPDFModal={openPDFModal}
                                            currentPDF={currentPDF}
                                            onClose={() => setOpenPDFModal(false)}
                                        />
                                    </>
                                ) : (
                                    <Grid container className={customFloatLeft}  item xs={6}>

                                                
                     
<Grid className={btnSpacing} item xs={12}>
                                                    <span>{index + 1 + '.'}</span> &nbsp;&nbsp;
                                                    <Button
                                                        color="primary"
                                                        // disabled={image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6'}
                                                        variant="contained"
                                                        onClick={image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6' ? null :
                                                        () => handleOpenImg(image.dataUrl)}
                                                    >
                                                     
                                                            {image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6' ?
                                                             "Html File" : "   Click to enlarge"}
                                                        
                                                    </Button> 
                                                    {/* <Button
                                                            color="primary"
                                                            disabled={image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6' }
                                                            variant="contained"
                                                            onClick={() => handleOpenImg(image.dataUrl)}
                                                        >
                                                            Click to enlarge
                                                            </Button> */}
                                                            {
                                                                image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6' ? 
                                                               <div>To see full report, please click download all button</div>:  <img src={image &&  image.dataUrl} key={`picture-${index}`} className={previewImg} />
                                                            }
                                                                                                             
                                                                {/* <img src={image &&  image.dataUrl} key={`picture-${index}`} className={previewImg} /> */}
                                                            
                                                    {/* <img src={image &&  image.dataUrl} key={`picture-${index}`} alt="To see full report, please download the file" className={previewImg} /> */}
                                                    {/* <img src={image.dataUrl} key={`picture-${index}`} alt="preview" className={previewImg} /> */}

                                                    <ImgSingleViewer
                                                        openImgModal={openImgModal}
                                                        currentImg={currentImg}
                                                        onClose={() => setOpenImgModal(false)}
                                                    />

                                                </Grid>
                                        </Grid>
                                    )
                        )
                            }
                            {images &&
                                images.length > 0 &&

                                <button className="custom-download-all-btn custom-attachment-btn popup-download-btn" onClick={() => downloadAll()}>Download All</button>
                            }
                        </div>
                    </Grid>
                        </div>
                </Grid>
                </div>
            </>
        );
}

const styles = () => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        padding: '0',
        width: '100%',
        height: '100%',
    },
    loading: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    visitInfo: {
        marginRight: '25px',
        '@media only screen and (max-width: 1024px)': {
            marginRight: '0',
            marginBottom: '25px',
        },
    },
    confirmationFields: {
        margin: '0',
    },
    confirmationCardAppointmentSection: {
        paddingBottom: '34px',
    },
    confirmationCardAppointmentSectionTitle: {
        fontSize: '12px',
        lineHeight: '14px',
        textTransform: 'uppercase',
        color: '#606A74',
        fontWeight: 'normal',
    },
    confirmationCardAppointmentSectionText: {
        color: '#1C2B39',
        fontWeight: '300',
        fontSize: '16px',
        lineHeight: '19px',
    },
    notes: {
        width: '100%',
    },
    previewImg: {
        maxWidth: 300,
        maxHeight: 300,
        marginBottom: '1em',
        marginTop: '1em'
    },
    customFloatLeft: {
        width: '50%',
        display: 'inline-block'
    },
    modal: {
        maxHeight: '700px',
        maxWidth: '700px !important'
    },
    textCenter: {
        textAlign: 'center'
    },
    btnSpacing: {
        marginBottom: '15px'
    }
});

export default withStyles(styles)(ApptRequestAttachmentPreview);


//  <Grid container item xs={12}>
// <Grid item xs={12}>
//   <Button
//     color="primary"
//     variant="contained"
//     onClick={() => handleOpenImg(image.dataUrl)}
//   >
//     Click to enlarge
// </Button>
// </Grid>
// <img src={image.dataUrl} key={`picture-${index}`} alt="preview" className={previewImg} />
// <ImgSingleViewer
//   openImgModal={openImgModal}
//   currentImg={currentImg}
//   onClose={() => setOpenImgModal(false)}
// />
// </Grid> 

{/* <a className="custom-popup-download-btn" target='_blank' href={image && image.dataUrl} download >Download</a> */ }